import { render, staticRenderFns } from "./TechRoadmap.vue?vue&type=template&id=919a858a&scoped=true&"
import script from "./TechRoadmap.vue?vue&type=script&lang=js&"
export * from "./TechRoadmap.vue?vue&type=script&lang=js&"
import style0 from "./TechRoadmap.vue?vue&type=style&index=0&id=919a858a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919a858a",
  null
  
)

export default component.exports